import { atomWithStorage } from 'jotai/utils';
import { SyncStorage } from 'jotai/vanilla/utils/atomWithStorage';
import { makeJotaiSessionStorage } from './createSessionStorage';

const initialUserInfoAtom: UserInfor = {
  usridx: 0,
  usrname: '',
  usremail: '',
  usrnickname: '',
  joindate: '',
  loginate: '',
  uid: '',
  dormantdate: null,
  isdormant: false
};

const localStorageKey = 'userInformation';
const userInforAtom = atomWithStorage(
  localStorageKey,
  initialUserInfoAtom,
  makeJotaiSessionStorage() as SyncStorage<UserInfor>
);

export default userInforAtom;
